<script>
import { Line } from "vue-chartjs";
import zoom from 'chartjs-plugin-zoom';

import * as moment from 'moment';
import 'moment/locale/he';

export default {
  extends: Line,
  props: ['clabels', 'cdata'],
  mounted() {
    let sets = [];
    for (let dataset in this.cdata) {
      sets.push(this.cdata[dataset]);
    }

    const LOCALE = Lang.get();

    moment.locale(LOCALE);
    let labels = [];
    for (let label in this.clabels) {
      labels[label] = moment(this.clabels[label]).toDate();
    }

    this.data = {
      labels: labels,
      datasets: sets
    };

    const TIMEFORMAT = 'MM/DD/YYYY HH:mm';
    this.options = {
      maintainAspectRatio:false,
      responsive: true,
      hoverMode: 'index',
      stacked: false,
      title:{
        display: false,
        text:''
      },
      tooltips: {
        rtl: LOCALE == 'he' ? true : false,
				intersect: false,
				mode: 'index',
				callbacks: {
					label: function(tooltipItem, myData) {
						let label = sets[tooltipItem.datasetIndex].label || '';
						if (label) {
              if (label == 'temperature' || label == 'טמפרטורה') {
                label += ': ℃';
                label += parseFloat(tooltipItem.value).toFixed(2);
              }
              if (label == 'humidity' || label == 'לחות') {
                label += ': ';
                label += parseFloat(tooltipItem.value).toFixed(0);
                label += '%';
              }
              if (label == 'light' || label == 'אור') {
                label += ': ';
                label += parseFloat(tooltipItem.value).toFixed(0);
                label += 'lx';
              }
						}
						return label;
					}
				}
			},

      scales: {
        xAxes: [{
					type: 'time',
					distribution: 'series',
					offset: true,
					ticks: {
						major: {
							enabled: true,
							fontStyle: 'bold'
						},
						source: 'data',
						autoSkip: true,
						autoSkipPadding: 75,
						maxRotation: 0,
						sampleSize: 100
					},
					afterBuildTicks: function(scale, ticks) {
						let majorUnit = scale._majorUnit;
						let firstTick = ticks[0];
						let i, ilen, val, tick, currMajor, lastMajor;

						val = moment(ticks[0].value);
						if ((majorUnit === 'minute' && val.second() === 0)
								|| (majorUnit === 'hour' && val.minute() === 0)
								|| (majorUnit === 'day' && val.hour() === 9)
								|| (majorUnit === 'month' && val.date() <= 3 && val.isoWeekday() === 1)
								|| (majorUnit === 'year' && val.month() === 0)) {
							firstTick.major = true;
						} else {
							firstTick.major = false;
						}
						lastMajor = val.get(majorUnit);

						for (i = 1, ilen = ticks.length; i < ilen; i++) {
							tick = ticks[i];
							val = moment(tick.value);
							currMajor = val.get(majorUnit);
							tick.major = currMajor !== lastMajor;
							lastMajor = currMajor;
						}
						return ticks;
					}
				}],
				yAxes: [{
					gridLines: {
						drawBorder: false,
					},
          ticks: {
            display: false,
          },
				}]
      },

      plugins: {
        zoom: {
          pan: {
            enabled: true,
            mode: 'x'
          },
          zoom: {
            enabled: true,
            mode: 'x',
          }
        }
      }
    };
    let YYYY = [
      {
        type: "linear",
        display: true,
        gridLines: true,
        position: "left",
        id: "y-temp",
        ticks: {
          fontColor: "#247BA0",
          callback: function(label) {
            return LOCALE == 'he' ? `℃${label}` : `${label}℃`;
          }
        },
      },
      {
        type: "linear",
        display: true,
        gridLines: true,
        position: "right",
        id: "y-humidity",
        ticks: {
          fontColor: "#c934ac",
          max: 100,
          min: 0,
          callback: function(label) {
              return label+'%';
          }
        },
      },
      {
        type: "linear",
        display: true,
        gridLines: true,
        position: "right",
        id: "y-light",
        ticks: {
          fontColor: "#fc9600",
          callback: function(label) {
              return parseFloat(label/1000).toFixed(1) +'K';
          }
        },
      }
    ];
    for (let i = 0; i < (this.data.datasets.length); i++) {
      this.options.scales.yAxes.push(YYYY[i])
    }
    this.addPlugin(zoom);
    this.renderChart(this.data, this.options);
  }
};
</script>
